module.exports = __webpack_public_path__ + "img/3.f3f9ff9a.png";